import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 更新 Dcoin 函数
 * @param {string} token 用户的 JWT Token
 * @param {string} username 用户名
 * @param {number} dcoinChange Dcoin 的变更值（正数或负数）
 * @returns {Promise<Object>} 返回后端的响应数据
 */
export const updateDcoin = async (
  token: string,
  username: string,
  dcoinChange: number
): Promise<any> => {
  try {
    const apiBaseUrl = getApiBaseUrl();

    const response = await axios.post(
      `${apiBaseUrl}/updateDcoin`,
      { username, dcoinChange },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // 返回后端响应数据
  } catch (err: any) {
    console.error('更新 Dcoin 失败:', err.message);
    if (err.response?.data?.error) {
      throw new Error(err.response.data.error);
    }
    throw new Error('更新 Dcoin 失败，请检查输入或网络连接');
  }
};

